import React from 'react'

import {
  Card,
  CardContent,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material'

const SocialRecord = (props) => {
  return (
    <Card sx={{ borderRadius: 2, p: 2 }}>
      <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography color='primary' variant='body1'>
              <b style={{ fontWeight: 900 }}>SOCIAL</b>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <List disablePadding>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Mejor amigo</b>} secondary='Sin definir' />
              </ListItem>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Compañeros con los que comparte gustos</b>} secondary='Sin definir' />
              </ListItem>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Compañeros con los que no le gusta pasar el tiempo</b>} secondary='Sin definir' />
              </ListItem>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Áreas de oportunidad</b>} secondary='Sin definir' />
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default SocialRecord